import request from '@/utils/request'; // 上传文件

export function uploadFile(data) {
  return request('/v1/template/uploadFile', {
    method: 'POST',
    data
  });
} // 上传文件base64

export function uploadBase64File(data) {
  return request('/v1/template/uploadBase64File', {
    method: 'POST',
    data
  });
} // 发送短信验证码

export function sendValidateCode(data) {
  return request('/v1/insure/sendValidateCode', {
    method: 'POST',
    data
  });
} // 保费试算

export function premiumCalculate(data) {
  return request('/v1/insure/premiumCalculate', {
    method: 'POST',
    data
  });
} // 查询订单详情

export const queryOrderDetail = data => {
  data.needAllInsured = true;
  return request('/v1/insure/queryOrderDetail', {
    method: 'POST',
    data
  });
}; // 获取智能问卷编号

export const queryNoticeQuestion = data => {
  return request('/v1/insure/queryNoticeQuestion', {
    method: 'POST',
    data
  });
}; // 获取智能问卷

export const getQuestionnaire = data => {
  return request('/v1/smartQuestion/getQuestionnaire', {
    method: 'POST',
    data
  });
}; // 获取多轮问卷

export const loopQuestionnaire = data => {
  return request('/v1/smartQuestion/loopQuestionnaire', {
    method: 'POST',
    data
  });
}; // 下一步操作

export const nextStep = data => {
  return request('/v1/insure/nextStep', {
    method: 'POST',
    data
  });
}; // 获取智能问卷核保答案服务

export const getAnswers = data => {
  return request('/v1/smartQuestion/getAnswers', {
    method: 'POST',
    data
  });
}; // 校验商品信息是否有效

export const checkGoodsInfo = data => {
  return request(`/v1/insure/checkGoodsInfo?promotionId=${data.promotionId}`, {
    method: 'POST'
  });
};